import { PixelPlaceholderLoader } from "@similarweb/ui-components";
import styled from "styled-components";

export const SummaryLoader = styled(PixelPlaceholderLoader).attrs({
    width: "100%",
    height: 160,
})`
    padding-top: 34px;
`;
